<template>
  <hero
    :title="$t('events.header.title')"
    :subtitle="$t('events.header.subtitle')"
    :title-color="'#fff'"
    :bg-image="'bnx_slider_2-min-scaled.jpg'"
  >
    <h3 class="page-title">{{ $t("events.pageTitle") }}</h3>

    <div class="events">
      <div class="event-wrapper" v-for="event in events">
        <EventBox :event="event" />
      </div>
    </div>
  </hero>

  <OurPartners @partnersLoaded="loaders.partners = true" />
</template>
<script>
import EventBox from "@/views/event/components/event-box";
import OurPartners from "@/components/shared/our-partners";
import Hero from "@/components/shared/hero";
import eventService from "@/services/EventService";
import misc from "@/core/helpers/misc";
export default {
  name: `EventList`,
  components: { EventBox, OurPartners, Hero },

  data() {
    return {
      events: [],
      misc: misc,
      loaders: {
        events: false,
        partners: false,
      },
    };
  },
  mounted() {
    this.getEvents();
  },
  methods: {
    async getEvents() {
      this.events = await eventService.getEvents();
      this.loaders.events = true;
    },
  },
};
</script>

<style scoped lang="scss">
.page-title {
  color: #000;
  font-family: DrukWideBoldItalic, Sans-serif;
  font-size: 35px;

  text-transform: uppercase;
  line-height: 1em;
  text-align: center;
  margin-bottom: 30px;
}

.events {
  max-width: 1200px;
  margin: 10px auto 20px;

  .event-wrapper {
    margin: 0 10px;
  }
}

@media only screen and (max-width: 1200px) {
  .page-title {
    font-size: 30px;
    margin-bottom: 15px;
  }
}

@media only screen and (max-width: 767px) {
  .page-title {
    font-size: 20px;
  }
}
</style>
